import moment from 'moment';

export type ResolverDataType = {
	[key: string]: any;
};

export type ResolverDataDetermineAgeType =
	| {
			birthdate: string;
	  }
	| ResolverDataType;

export type ConvertResolverToTrackableDataType = {
	[key: string]: () => Object;
};

const convertResolverToUserData = (Views: { [key: string]: number }) => {
	return {
		[Views.SELECT_COACH]: (resolverData: ResolverDataType): Object => resolverData,
		[Views.SELECT_GENDER]: (resolverData: ResolverDataType): Object => resolverData,
		[Views.DETERMINE_AGE]: (resolverData: ResolverDataDetermineAgeType): Object => {
			return {
				...resolverData,
				birthdate: {
					date: resolverData.birthdate,
					dayOfMonth: parseInt(moment(resolverData.birthdate).format('DD'), 10),
					monthValue: parseInt(moment(resolverData.birthdate).format('MM'), 10),
					year: parseInt(moment(resolverData.birthdate).format('YYYY'), 10),
				},
			};
		},
		[Views.DETERMINE_SIZE]: (resolverData: ResolverDataType): Object => resolverData,
		[Views.DETERMINE_WEIGHT]: (resolverData: ResolverDataType): Object => resolverData,
		[Views.DEFINE_HEALTH_TARGET]: (resolverData: ResolverDataType): Object => resolverData,
		[Views.ACCEPT_HEALTH_TARGET]: (resolverData: ResolverDataType): Object => resolverData,
		[Views.SELECT_DIETARY_HABITS]: (resolverData: ResolverDataType): Object => resolverData,
		[Views.SELECT_ACTIVITY_LEVEL]: (resolverData: ResolverDataType): Object => resolverData,
		[Views.VERIFY]: (resolverData: ResolverDataType): Object => resolverData,
		[Views.DSGVO]: (resolverData: ResolverDataType): Object => resolverData,
		[Views.DISCLAIMER]: (resolverData: ResolverDataType): Object => resolverData,
	};
};

export default convertResolverToUserData;
